import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@mui/material";
import EquipmentService from "../../../services/Equipment.service";

export default function EditTaggedOutDescriptionDialog({ open, onClose, issue, onUpdated }) {
    const [description, setDescription] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (open && issue) setDescription(issue.description || "");
    }, [open, issue]);

    if (!issue) return null;

    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const res = await EquipmentService.updateIssue(issue.id, { description });
            onUpdated?.(res.data);
            onClose();
        } catch {
            setError("Failed to update the description.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Edit Issue Description</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    fullWidth
                    multiline
                    minRows={3}
                    error={Boolean(error)}
                    helperText={error}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" disabled={saving} onClick={handleSave}>
                    {saving ? "Saving…" : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
